import { render, staticRenderFns } from "./ViewReceipt.vue?vue&type=template&id=0ad1117b"
import script from "./ViewReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewReceipt.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports